import { http, createConfig } from 'wagmi';
import { bsc, mainnet, polygon } from 'wagmi/chains';
import { walletConnect } from 'wagmi/connectors';

export const chains = [
  bsc,           // Mainnet: BSC (PRIMARY)
  mainnet,       // Mainnet: Ethereum
  polygon,       // Mainnet: Polygon
] as const;

/**
 * WalletConnect Project ID
 *
 * IMPORTANT: This is hardcoded here to ensure consistency across all environments.
 * Get your Project ID at: https://cloud.reown.com or https://cloud.walletconnect.com
 *
 * Current Project ID: ee35dbf49aebc9f7678bafb8c883706d
 * Manage at: https://cloud.reown.com
 */
export const projectId = 'ee35dbf49aebc9f7678bafb8c883706d';

/**
 * Metadata for WalletConnect and Web3Modal
 */
export const metadata = {
  name: 'Farcana',
  description: 'Farcana Web3 Platform',
  url: typeof window !== 'undefined' ? window.location.origin : 'https://farlabs.sakura.exchange',
  icons: ['https://avatars.githubusercontent.com/u/37784886'],
};

// Log for debugging
if (import.meta.env.DEV) {
  // eslint-disable-next-line no-console
  console.log('[web3-config] WalletConnect Project ID:', projectId);
}

/**
 * Wagmi configuration for Web3Modal
 *
 * Web3Modal will automatically detect and support:
 * - Binance Wallet (browser extension)
 * - MetaMask (browser extension)
 * - Trust Wallet (mobile via WalletConnect)
 * - 300+ other wallets
 *
 * Note: MetaMask and other browser extensions are auto-detected via EIP-6963
 */
export const config = createConfig({
  chains,
  connectors: [
    // WalletConnect v2 - Web3Modal will handle UI and wallet detection
    // Note: MetaMask and other browser extensions are auto-detected via EIP-6963
    walletConnect({
      projectId,
      metadata,
      showQrModal: false, // Web3Modal handles the modal UI
    }),
  ],
  transports: {
    [bsc.id]: http(),
    [mainnet.id]: http(),
    [polygon.id]: http(),
  },
});
